// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1kWNK","right":"styles_right__2vWhJ"};